define(
    'BannerCategoryView',[
        'jquery',
        'backbone',
        'app',
        'SubView',
        'InternalLinkView',
        'template!blocks/banner-category'
    ],
    function (
        $,
        Backbone,
        app,
        SubView,
        InternalLinkView,
        BannerCategoryTemplate
    )
{
    var BannerView = Backbone.View.extend(SubView).extend({
        events: {
            'click .banner-category__link' : 'onclick'
        },
        initialize:function(options) {
            var view = this;
            view.id_banner = view.$el.data('banner').toString();
            view.banner = app.getBanner(view.id_banner);
            view.el.bannerCategory = true;
            view.listenTo(app, 'listingFilterChange', view.onFilterChange);
        },
        setup:function(){
        },
        afterRender:function(){
            var mode_display = this.banner.get('mode_display');
            if (!mode_display) {
                InternalLinkView.initializeLinksOfView(this);
            }
        },

        onclick:function(e) {
            var banner = this.banner,
                id_product = banner.get('id_product'),
                discount = banner.get('discount'),
                mode_display = banner.get('mode_display'),
                cart = app.getCart();

            if (!mode_display) {
                return false;
            }

            e.preventDefault();
            if ((mode_display === '1' || mode_display === '2') && id_product) { // if link product or add to cart
                var product = app.getProduct(id_product);
                
                if (mode_display === '1') {// if add to cart
                    if (product.isBuyableInContext(cart) && !product.isMenu()) {
                        // si c'est un produit simple et disponible, on l'ajoute directement
                        app.banNotice(t('Produit ajouté au panier', 'Cart'));
                        return cart.addProduct(product.id);
                    }
                }
                // dans tous les autres cas, on affiche la fiche produit
                return app.go('product', {product:product});
            } else if (mode_display == '3' && discount) {
                // ou sinon, si c'est un bon de réduction, on l'ajoute au panier
                return cart.addVoucher(discount);
            }
        },

        onFilterChange: function() {
            this.$el.toggleClass('hide', app.getTags().isAllChecked())
        }
    });

    BannerView.initializeBannercategoryOfView = function (view)
    {
        return BannerView.initializeBannercategoryOfEl(view.$el);
    };
    BannerView.initializeBannercategoryOfEl = function ($el)
    {
        var views = [];
        $el.find('.banner-category').each(function ()
        {
            if(this.bannerCategory) return;
            views.push(new BannerView({el: this}));
        });
        return true;
    };

    return BannerView;
});
